import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Alert, Button, Col, Modal, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';
import * as mixpanel from 'mixpanel-browser';
import LocationSelection from './search-box/LocationSelection';
import DateRangeSelection from './search-box/DateRangeSelection';
import GuestRoomSelection from './search-box/GuestRoomSelection';
import MoreSettings from './search-box/MoreSettings';
import SortingSelection from './search-box/SortingSelection';
import MapSeletion from './search-box/MapSection';
import useSearchHooks from '../../store/hotel/search-hooks';
import usePricelineStore from '../../store/hotel/priceline';
import { validationSearchParams } from '../../helper/validation';

export default function SearchSection() {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState([]);
  const [show, setShow] = useState(false);
  const { list: pricelineHotelList, error: pricelineError } = usePricelineStore((state) => ({
    list: state.list,
    error: state.error,
  }));
  const { startSearch, search } = useSearchHooks();

  const resetSearch = () => {
    search.reset();
  };
  // const mixpanel = require('mixpanel-browser');

  // eslint-disable-next-line consistent-return
  const submitSearch = async (queryParams = null) => {
    if (queryParams === null) {
      setError(validationSearchParams(search));
      startSearch();
    } else {
      setError(validationSearchParams(queryParams));
      search.setParams(queryParams);
      if (error.length === 0) {
        startSearch();
      }
    }
  };

  const handleClose = () => setShow(false);
  const applyMembership = () => {
    handleClose();
    window.location = '/';
  };
  useEffect(() => {
    const obj = Object.fromEntries([...searchParams]);
    if (searchParams.get('checkIn') && searchParams.get('checkOut')) submitSearch(obj);
  }, []);

  const propsAreEqual = (prevProps, nexProps) => {
    return pricelineHotelList.length === nexProps.length;
  };

  const Maps = React.memo(MapSeletion, propsAreEqual);

  const showAlert = () => {
    if (error.length === 0) {
      return '';
    }
    return (
      <Row className="position-absolute w-100">
        <Col>
          <Alert key="warning" variant="warning">
            {error.map((e) => (
              <h6 className="m-0 text-danger">{e}</h6>
            ))}
          </Alert>
        </Col>
      </Row>
    );
  };
  useEffect(() => {
    if (pricelineHotelList && pricelineError) {
      if (pricelineError.status === 403) {
        setShow(true);
      }
    }
  }, [pricelineHotelList]);

  const showWarning = () => {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="bg-dark" />
        <Modal.Body className="bg-dark">
          Select Hotels rates are subject to private rate agreements and can only be viewed by members.
          <br /> You can view some brands with preferred rates and VIP perk & amenity programs for members below.
        </Modal.Body>
        <Modal.Footer className="bg-dark">
          <Button variant="secondary" className="col text-center topBarApplyBtnTxt" onClick={applyMembership}>
            Apply for Membership
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  return (
    <div className="position-relative p-3 p-md-5 m-md-3 text-center search-wrapper search-settings">
      <div className="col-md-10 mx-auto my-5 rs-search-box">
        <div className="display-4 fw-normal hotel_welcome">
          <div className="title_name">
            <h2 className="lead fw-normal welcome_msg">
              Over A Million <span>Hotels</span>
            </h2>
            <h2 className="lead fw-normal welcome_msg">Across The Globe</h2>
            <p className="lead fw-normal welcome_desc">Up to 60% off bookings at 200,000+hotels, and up to 10% cash back at over a million more.</p>
          </div>
        </div>
        <div className="closeForm d-sm-none d-md-block">
          <Button className="btns d-block" onClick={() => resetSearch()}>
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </div>
        <form name="hotel" className="rs_hotel_form w-100">
          <LocationSelection />
          <DateRangeSelection />
          <GuestRoomSelection />
          <div className="rs_button_row rs_1365_100">
            <Button
              className="btn-dark rs_search rs_initial_hide priceline-search-button"
              title="Search"
              onClick={() => {
                submitSearch();
                mixpanel.init('f7c2b5bee408ce64398ba6934f6dab84');
                mixpanel.track('Benefit Link Clicked', { 'Benefit Type': 'Hotel', 'Benefit Name': 'search hotel' });
              }}
            >
              Search Hotels
            </Button>
            <Button color="link" variant="link" className="d-sm-block d-md-none mt-3" onClick={() => resetSearch()}>
              Reset Search
            </Button>
          </div>
        </form>
        {showAlert()}
        {showWarning()}
        {pricelineHotelList.length > 0 ? (
          <>
            <MoreSettings />
            <SortingSelection />
            <Maps />
          </>
        ) : null}
      </div>
    </div>
  );
}
